import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../Home/Home.css';
import './PurchaseConfirmation.css';
import logo from '../Login/logo.png';

export default function PurchaseConfirmation() {
  const navigate = useNavigate();
  const location = useLocation();
  const telefono = location.state?.telefono || location.state?.phone || '—';
  const correo = location.state?.correo || location.state?.email || '—';

  return (
      <div className="app-container">
        <div className="pc-page">
          <header className="topbar" role="banner">
            <div className="brand">
              <img src={logo} alt="Logo reANIDArt - Muestra 1 pájaro con dos polluelos en un nido de ramas con hojas alrededor" onClick={() => navigate('/home')} className="brand-logo" />
              <nav className="nav" aria-label="navegación principal">
                <button className="nav-link active" onClick={() => navigate('/home')}>Inicio</button>
                <button className="nav-link" onClick={() => navigate('/profile')}>Mi nido</button>
              </nav>
            </div>
            <div className="right" />
              <title>ReANIDArt - Confirmación de compra</title>
          </header>

          <main className="pc-content" role="main">
            <section className="pc-card" role="region" aria-labelledby="pc-title">
              <h1 id="pc-title" className="pc-title" role="status" aria-live="polite">¡Compra realizada con éxito!</h1>
              <p className="pc-sub">Gracias por tu compra. Tu transacción se ha completado correctamente.</p>

              <div className="pc-info">
                <h2 className="pc-info-title">Información de contacto del vendedor</h2>
                <div className="pc-info-block">
                  <div className="pc-strong">Teléfono: {telefono}</div>
                  <div className="pc-strong">Correo Electrónico: {correo}</div>
                </div>
              </div>

              <div className="pc-actions">
                <button className="pc-btn" onClick={() => navigate('/home')}>Volver al inicio</button>
              </div>
            </section>
          </main>
        </div>
      </div>
  );
}
